// Helper function to parse amount from amount_with_symbol
export const parseAmountFromSymbol = (amountWithSymbol) => {
  if (!amountWithSymbol) return { amount: 0, formatPattern: '$1' }

  let cleanedAmount = amountWithSymbol.replace(/[^0-9.,-]/g, '')

  // Determine decimal format and clean the amount
  if (cleanedAmount.includes(',')) {
    const lastDotIndex = cleanedAmount.lastIndexOf('.')
    const lastCommaIndex = cleanedAmount.lastIndexOf(',')

    if (lastCommaIndex > lastDotIndex) {
      cleanedAmount = cleanedAmount.replace(/\./g, '').replace(',', '.')
    } else {
      cleanedAmount = cleanedAmount.replace(/,/g, '')
    }
  }

  // Create a regex pattern to rebuild the formatted string
  // Replace the numeric part with a placeholder that can be substituted
  const formatPattern = amountWithSymbol.replace(/[\d.,,-]+/, '$1')

  return {
    amount: Number(cleanedAmount),
    formatPattern
  }
}

// Helper function to calculate final payment amount considering coupons
export const calculateFinalPaymentAmount = (amountWithSymbol, couponData) => {
  if (!couponData?.resource) {
    return amountWithSymbol
  }

  const parsed = parseAmountFromSymbol(amountWithSymbol)
  const MINIMUM_CHARGE_AMOUNT = 0.50
  const coupon = couponData.resource
  const originalAmount = parsed.amount
  const formatPattern = parsed.formatPattern

  let finalAmount
  if (coupon.fixed_amount_cents) {
    finalAmount = originalAmount - coupon.fixed_amount_cents / 100
  } else if (coupon.percent_off) {
    finalAmount = originalAmount * (1 - coupon.percent_off / 100)
  } else {
    finalAmount = originalAmount
  }

  if (finalAmount <= 0) {
    finalAmount = 0
  } else if (finalAmount < MINIMUM_CHARGE_AMOUNT && finalAmount > 0) {
    finalAmount = MINIMUM_CHARGE_AMOUNT
  }

  const formattedAmount = finalAmount.toFixed(2)
  return formatPattern.replace('$1', formattedAmount)
}
